export const INPUT_NUMBER_ALLOW_KEY_CODE = [
    37, 38, 39, 40, 8, 17, 18, 20, 46, 35, 13, 27, 112, 113, 114, 115, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105,
    34, 33, 19, 44, 145, 9, 116, 117, 118, 119, 120, 121, 122, 123, 36, 45, 144, 110, 49, 50, 51, 52, 53, 54, 55, 56,
    57, 48, 188, 190
]
